var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { useAnimateTransition } from '../hooks';
import Card from './card';
function NotificationInternal(_a) {
    var title = _a.title, description = _a.description, _b = _a.mode, mode = _b === void 0 ? 'inline' : _b, _c = _a.variant, variant = _c === void 0 ? 'info' : _c, _d = _a.inverted, inverted = _d === void 0 ? false : _d, _e = _a.closable, closable = _e === void 0 ? false : _e, onClose = _a.onClose, action = _a.action, closeButtonOverride = _a.closeButtonOverride, restProps = __rest(_a, ["title", "description", "mode", "variant", "inverted", "closable", "onClose", "action", "closeButtonOverride"]);
    var _f = __read(useState(true), 2), isOpen = _f[0], setIsOpen = _f[1];
    var isAnimating = useAnimateTransition(isOpen, 400);
    function handleClose() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setIsOpen(false);
    }
    return isAnimating ? (_jsx(Card, __assign({}, {
        title: title,
        description: description,
        variant: variant,
        mode: mode,
        inverted: inverted,
        closable: closable,
        action: action,
        closeButtonOverride: closeButtonOverride,
    }, restProps, { isVisible: isOpen, onClose: handleClose }))) : null;
}
export default NotificationInternal;
